import React from 'react';
import PropTypes from 'prop-types';
import styles from './InitWrapper.scss';
import { translate } from 'react-i18next';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import Users from 'wix-ui-icons-common/Users';
import Settings from 'wix-ui-icons-common/Settings';
import { Button, PageHeader, Page, PopoverMenu } from 'wix-style-react';

function ActionBar({ onTakePhoneOrderClick, displayCta, onSettingsClick, t, onRolesAndPermissionsClick }) {
  return (
    <div className={styles.actionBar}>
      <PopoverMenu
        dataHook="popover-menu-cta"
        minWidth={240}
        triggerElement={
          <Button skin="light" suffixIcon={<ChevronDown />} dataHook="welcome-cta">
            {t('phoneordering_bm_dashboard_ordersettings_app_header_CTA_secondary')}
          </Button>
        }
      >
        <PopoverMenu.MenuItem
          dataHook="settings-button"
          prefixIcon={<Settings />}
          text={t('phoneordering_bm_dashboard_ordersettings_app_header_CTA_secondary_dropdown_settings')}
          onClick={() => onSettingsClick()}
        />
        <PopoverMenu.MenuItem
          dataHook="roles-and-permissions-button"
          prefixIcon={<Users />}
          text={t('phoneordering_bm_dashboard_ordersettings_app_header_CTA_secondary_dropdown_roles')}
          onClick={() => onRolesAndPermissionsClick()}
        />
      </PopoverMenu>
      {displayCta && (
        <React.Fragment>
          <div className={styles.spacer} />
          <Button dataHook="welcome-cta-title" onClick={onTakePhoneOrderClick}>
            {t('phoneordering_bm_dashboard_ordersettings_app_header_CTA_NewOrder')}
          </Button>
        </React.Fragment>
      )}
    </div>
  );
}

function InitWrapper({
  onTakePhoneOrderClick,
  displayCta,
  children,
  settingsText,
  onSettingsClick,
  t,
  onRolesAndPermissionsClick,
}) {
  return (
    <div className={styles.wrapper}>
      <Page>
        <PageHeader
          title={t('phoneordering_common_header_phoneordering')}
          actionsBar={
            <ActionBar
              onTakePhoneOrderClick={onTakePhoneOrderClick}
              displayCta={displayCta}
              settingsText={settingsText}
              onSettingsClick={onSettingsClick}
              onRolesAndPermissionsClick={onRolesAndPermissionsClick}
              t={t}
            />
          }
        />
        <Page.Content>
          <div className={styles.emptyState}>{children}</div>
        </Page.Content>
      </Page>
    </div>
  );
}

InitWrapper.displayName = 'InitWrapper';
InitWrapper.propTypes = {
  onTakePhoneOrderClick: PropTypes.func,
  children: PropTypes.node,
  displayCta: PropTypes.bool,
  settingsText: PropTypes.string,
  onSettingsClick: PropTypes.func,
  t: PropTypes.func,
};

export default translate()(InitWrapper);
